import s from './style.module.scss';
import GrtImage from '@/components/GrtImage';
import { Display } from '@/components/Display/Display';
import { useEffect, useState } from 'react';
import MyIcon from '@/components/MyIcon';
import { showPopup, hidePopup } from '@/utils/Page/modal';
import { handleCheckBusinessStatus, handleGetProjectListByCourseId } from '@/utils/Page/personalRecommend';
import { getCorrespondLabel } from '@/utils/global';
import { Hide } from '@/components/Hide';
import { getTime } from './utils';
import { CloseOutline } from 'antd-mobile-icons';

const WebResult = (props) => {
    const { resources = [] } = props;
    const [expand, setExpand] = useState(false);
    const [list, setList] = useState([]);
    const [expandProjectId, setExpandProjectId] = useState(null);
    const [expandProjectListMap, setExpandProjectListMap] = useState({});
    const toggleExpand = () => {
        setExpand(!expand);
    };
    const handleList = () => {
        let data = [];
        if (!expand) {
            data = resources?.slice(0, 3);
        } else {
            data = resources;
        }
        data.forEach((ele) => {
            ele.projectList = ele?.project_list || [];
            ele.expand = false;
        });
        setList(data);
    };
    useEffect(() => {
        handleList();
    }, [expand, resources]);

    //关闭多项目选择
    const closeChose = () => {
        setExpandProjectId(null);
    };
    //点击立即学习
    const clickLearn = async (data) => {
        //点播课，校验是否在多项目中
        if (data.template_id === 0) {
            //已经展开过，直接取map里的值
            if (expandProjectListMap?.[data?.business_id]) {
                setExpandProjectId(data?.business_id);
                return;
            }
            //校验业务状态
            let projectList = await handleGetProjectListByCourseId({ course_id: data?.business_id }, 'mobile');
            //多项目选择
            if (projectList.length > 0) {
                setExpandProjectId(data?.business_id);
                setExpandProjectListMap({
                    ...expandProjectListMap,
                    [data?.business_id]: projectList
                });
                // showPopup(<ChoseProject list={list} onClose={closeChose}></ChoseProject>, {}, modalName.chose);
            }
        } else {
            await handleCheckBusinessStatus({ template_id: data?.template_id, business_id: data?.business_id });
        }
    };
    //    关闭全部

    return (
        <>
            <div className={s['box-wrap']}>
                <>
                    <Display show={list.length > 0}>
                        <div className={s['list-wrap']}>
                            {list.map((ele, index) => {
                                return (
                                    <div key={index} className={s['list-item']}>
                                        <div className={s['course-item']}>
                                            <GrtImage src={ele?.image_url}></GrtImage>
                                            <div className={s['info-wrap']}>
                                                <div className={s['course-title']}>{ele.business_name}</div>
                                                <div className={s['list-action']}>
                                                    <span className={s['type']}>
                                                        {ele.template_id === 0 ? '点播课' : getCorrespondLabel(ele.template_id)}
                                                    </span>
                                                    <span
                                                        data-type={'primary'}
                                                        data-disabled={ele?.business_id === expandProjectId}
                                                        onClick={() => {
                                                            clickLearn(ele, index);
                                                        }}
                                                        className={s['action-button']}
                                                    >
                                                        立即学习
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <Hide show={ele?.business_id === expandProjectId}>
                                            <div className={s['project-box']}>
                                                <div className={s['tip-title']}>
                                                    <span className={s['title-text']}>该点播课存在多个项目下，请选择一个进行学习</span>
                                                    <span className={s['close-icon']} onClick={closeChose}>
                                                        <CloseOutline />
                                                    </span>
                                                </div>
                                                <div className={s['project-list']}>
                                                    {expandProjectListMap?.[ele?.business_id]?.map((item, index) => {
                                                        return (
                                                            <div
                                                                key={index}
                                                                className={s['project-item']}
                                                                onClick={() => {
                                                                    clickLearn(item);
                                                                }}
                                                            >
                                                                <div className={s['project-title']}>{item.business_name}</div>
                                                                <div className={s['project-time']}>
                                                                    <span className={s['time-text']}>
                                                                        {getTime(item.end_state, item.start_time, item.end_time) || ''}
                                                                    </span>
                                                                    <span className={s['arrow-icon']}>
                                                                        <MyIcon type="icon-youjiantou"></MyIcon>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </Hide>
                                    </div>
                                );
                            })}
                        </div>
                        <Display show={resources?.length >= 3}>
                            <div className={s['expand-box']} onClick={toggleExpand}>
                                <MyIcon
                                    style={{ fontSize: '20px', cursor: 'pointer' }}
                                    type={expand ? 'icon-a-Frame427319955' : 'icon-a-Frame4273199541'}
                                ></MyIcon>
                            </div>
                        </Display>
                    </Display>
                </>
            </div>
        </>
    );
};

export default WebResult;
